import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {environment} from '../../env';
import {InsightsGroupTotal, StockInsightsQuery, StockInsightsReport} from '../../models/insights';
import {AppLogger, AppLoggerService} from '../../core/logging';

@Injectable({
  providedIn: 'root'
})
export class InsightsService {

  private readonly log: AppLogger;

  constructor(private http: HttpClient, appLogger: AppLoggerService) {
    this.log = appLogger.createForClass(InsightsService);
  }

  getStockInsights(householdId: number, query: StockInsightsQuery = {}): Observable<StockInsightsReport> {
    let params = new HttpParams();
    if (query.groupBy) params = params.set('group_by', query.groupBy);
    if (query.from) params = params.set('from', query.from);
    if (query.to) params = params.set('to', query.to);
    if (query.productId != null) params = params.set('product_id', query.productId);
    if (query.productKind) params = params.set('product_kind', query.productKind);
    if (query.category) params = params.set('category', query.category);
    if (query.limit != null) params = params.set('limit', query.limit);

    return this.http.get<StockInsightsReport>(
      `${environment.apiUrl}/households/${householdId}/insights/stock`, {params}
    );
  }

  /**
   * There is no per-product stats endpoint — filtering the household report by
   * product_id narrows it to exactly one group, which is the product's stats.
   * Resolves to null when nothing was recorded in the window.
   */
  getProductInsights(householdId: number, productId: number, from?: string, to?: string): Observable<InsightsGroupTotal | null> {
    return this.getStockInsights(householdId, {groupBy: 'product', productId, from, to})
      .pipe(map(report => report.groups?.[0] ?? null));
  }
}
